import {
  ADD_BULK_DATA,
  ALL_BRANCH,
  ALL_COUNSELOR,
  ALL_DOCTOR,
  ALL_DOCTOR_SEARCH,
  ALL_PATIENT,
  ALL_PATIENT_SEARCH,
  CREATE_LEAD,
  DELETE_LEAD,
  GET_ALL_LEAD,
  GET_FOLLOWUP,
  GET_NEXT_FOLLOWUP,
  GET_PATIENT_EXCEL,
  SEARCH_ALL_COUNSELOR,
  SEARCH_LEAD,
  UPDATE_LEAD,
  VERIFY_OTP,
  VIEW_LEAD,
  GET_DYNAMIC_FIELDS,
  GET_WORK_REPORT,
} from '../actions/Files.action';

const initialState = {
  createLead: '',
  getAllLead: '',
  updateLead: '',
  deleteLead: '',
  verifyOtp: '',
  viewLead: '',
  allPatient: '',
  allBranch: '',
  allDoctor: '',
  allCounselor: '',
  getFollowup: '',
  getNextFollowup: '',
  addBulkData: '',
  getPatientExcel: '',
  getDynamicFields: '',
};

const filesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_LEAD:
      return { ...state, createLead: action.payload };
    case GET_ALL_LEAD:
      return { ...state, getAllLead: action.payload };
    case UPDATE_LEAD:
      return { ...state, updateAllFile: action.payload };
    case DELETE_LEAD:
      return { ...state, deleteLead: action.payload };
    case VERIFY_OTP:
      return { ...state, verifyOtp: action.payload };
    case SEARCH_LEAD:
      return { ...state, getAllLead: action.payload };
    case VIEW_LEAD:
      return { ...state, viewLead: action.payload };
    case ALL_PATIENT:
      return { ...state, allPatient: action.payload };
    case ALL_PATIENT_SEARCH:
      return { ...state, allPatient: action.payload };
    case ALL_BRANCH:
      return { ...state, allBranch: action.payload };
    case ALL_DOCTOR:
      return { ...state, allDoctor: action.payload };
    case ALL_DOCTOR_SEARCH:
      return { ...state, allDoctor: action.payload };
    case ALL_COUNSELOR:
      return { ...state, allCounselor: action.payload };
    case SEARCH_ALL_COUNSELOR:
      return { ...state, allCounselor: action.payload };
    case GET_FOLLOWUP:
      return { ...state, getFollowup: action.payload };
    case GET_NEXT_FOLLOWUP:
      return { ...state, getNextFollowup: action.payload };
    case ADD_BULK_DATA:
      return { ...state, addBulkData: action.payload };
    case GET_PATIENT_EXCEL:
      return { ...state, getPatientExcel: action.payload };
    case GET_DYNAMIC_FIELDS:
      return { ...state, getDynamicFields: action.payload };
    case GET_WORK_REPORT:
      return {
        ...state,
        getWorkReport: action.payload,
      };
    default:
      return state;
  }
};

export default filesReducer;
